<section id="integrations" class="bg-white py-24">
  <div class="mx-auto flex max-w-page flex-col gap-16 px-4 sm:px-6 lg:px-8">
    <div class="mx-auto flex max-w-3xl flex-col gap-6 text-center">
      <div class="flex flex-col gap-3">
        <p class="text-caption font-semibold uppercase tracking-[0.2em] text-slate-500">Integrations</p>
        <h2 class="text-h2 font-medium text-slate-950">Connect your operational stack.</h2>
      </div>
      <p class="text-body1 leading-8 text-slate-600">
        Integrate FormOps with scheduling, CRM, communication,
        and automation platforms.
      </p>
    </div>

    <div class="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
      <div class="flex flex-col items-center gap-5 rounded-3xl border border-slate-200 bg-slate-50/40 p-6 text-center">
        <div class="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary-50 text-primary-600">
          <svg class="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.8"
              d="M8 7V3m8 4V3M5 11h14M6 5h12a2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V7a2 2 0 012-2z" />
          </svg>
        </div>
        <div class="flex flex-col gap-2">
          <p class="text-h6 text-slate-950">Calendly</p>
          <p class="text-body3 text-slate-500">Booking workflows</p>
        </div>
      </div>

      <div class="flex flex-col items-center gap-5 rounded-3xl border border-slate-200 bg-slate-50/40 p-6 text-center">
        <div class="flex h-14 w-14 items-center justify-center rounded-2xl bg-success-50 text-success-600">
          <svg class="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div class="flex flex-col gap-2">
          <p class="text-h6 text-slate-950">Zoho Bookings</p>
          <p class="text-body3 text-slate-500">Scheduling automation</p>
        </div>
      </div>

      <div class="flex flex-col items-center gap-5 rounded-3xl border border-slate-200 bg-slate-50/40 p-6 text-center">
        <div class="flex h-14 w-14 items-center justify-center rounded-2xl bg-secondary-50 text-secondary-600">
          <svg class="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.8"
              d="M7 8h10M7 12h6m-8 8l4-4h8a3 3 0 003-3V7a3 3 0 00-3-3H7a3 3 0 00-3 3v6a3 3 0 003 3h1l-3 4z" />
          </svg>
        </div>
        <div class="flex flex-col gap-2">
          <p class="text-h6 text-slate-950">Slack</p>
          <p class="text-body3 text-slate-500">Notifications & alerts</p>
        </div>
      </div>

      <div class="flex flex-col items-center gap-5 rounded-3xl border border-slate-200 bg-slate-50/40 p-6 text-center">
        <div class="flex h-14 w-14 items-center justify-center rounded-2xl bg-warning-50 text-warning-700">
          <svg class="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.8"
              d="M8 7V3m8 4V3M5 11h14M6 5h12a2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V7a2 2 0 012-2z" />
          </svg>
        </div>
        <div class="flex flex-col gap-2">
          <p class="text-h6 text-slate-950">Google Calendar</p>
          <p class="text-body3 text-slate-500">Event scheduling</p>
        </div>
      </div>
    </div>
  </div>
</section>
